/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import { bus } from '@/main';
import commonSocketConnectMethod from "@/services/commonSocket";
import moment from 'moment';

export default {
  name: 'chat-of-patient',
  components: {},
  props: ['chateRoomIdOfPateint'],
  data() {
    return {
      selfUserId: '',
      selfUserInfo: null,
      patientChatDetails: null,
      patientChatDetailResults: [],
      selection_type: 'press_enter',
      callTextState: false,
      typingUserInfoState: null,
      doctorInfo: null,
      patientChatScoket: null,
      msgNextPageLoader: '',
      lastLiveMsgData:null
    }
  },
  computed: {
    reversedChatListResults() {
      return [...this.patientChatDetailResults].reverse();
    },
  },
  mounted() {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID');
      this.selfUserInfo = JSON.parse(localStorage.getItem('LoginedUserInfo'));
    }

    if (this.chateRoomIdOfPateint) {
      this.doctorInfo = this.chateRoomIdOfPateint.doctor_detail;
      this.createRoomWithPatient(this.chateRoomIdOfPateint.chat_room_id);
    }

    bus.$on('userUpdateStatus', (data) => {
      let user = this.chateRoomIdOfPateint.id == data.userID;
      if (user) {
        this.chateRoomIdOfPateint.is_online = data.is_online;
      }
    });

    bus.$on('typingEventForChatBus', (data) => {
      this.typingUserInfoState = data;
      if (data.message == 'stop') {
        this.typingUserInfoState = null;
      }
    });
    
    this.handleMessageLoader();
  },
  methods: {
    messagesIndicationStatusMethod(item) {
      if (!item) return;
      const allRead = item.every(status => status.is_read);
      const allDelivered = item.every(status => status.is_delivered);
      if (allRead) {
        return 'read';
      } else if (allDelivered) {
        return 'delivered';
      } else {
        return 'undelivered';
      }
    },
    formatDateSeparator(timestamp) {
      const date = new Date(timestamp);
      const options = { month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
    handleMessageLoader() {
      const elmntList = document.getElementById("chat_msg_list_scroll");
      if (!elmntList) return;
      elmntList.addEventListener("scroll", () => {
        if (elmntList.scrollTop === 0) {
          if (this.msgNextPageLoader) {
            axios.get(this.msgNextPageLoader)
              .then((response) => {
                if (response.status === 200 && response.data && response.data.data) {
                  const { next, results } = response.data.data;
                  const previousScrollHeight = elmntList.scrollHeight;

                  this.msgNextPageLoader = next;
                  this.patientChatDetailResults = [...this.patientChatDetailResults, ...results];

                  this.$nextTick(() => {
                    elmntList.scrollTop = elmntList.scrollHeight - previousScrollHeight;
                  });
                }
              })
              .catch((err) => {
                console.error("Error loading older messages:", err);
              });
          }
        }
      });
    },
    
    newline() { },
    send() { },

    enabledYearDateFun(msgDateTime) {
      var currentLocalDate = moment().format('YYYY');
      var startDateCheck = moment(msgDateTime).format('YYYY')
      if (currentLocalDate > startDateCheck) {
        return true;
      } else {
        return false;
      }
    },

    createRoomWithPatient(createdRoomChatId) {
      this.lastLiveMsgData = null;
      const authToken = localStorage.getItem('token');

      this.$store.dispatch('getChatRoomDetailForPatientMethod', { id: createdRoomChatId })
        .then(response => {
          const { data } = response.data;
          this.patientChatDetails = data;
          this.patientChatDetailResults = [].concat(data.results);
          this.msgNextPageLoader = data.next;
          this.chatScrollAlwaysBottomMethod();

          this.setupChatSocket(createdRoomChatId, authToken);
        })
        .catch(error => {
          console.error('Failed to get chat room details:', error);
        });
    },

    setupChatSocket(roomId, token) {
      const messagesList = document.getElementById('list_of_patient_chat_msg_wrp');

      this.patientChatScoket = new WebSocket(
        `wss://${process.env.VUE_APP_WEBSOCKET_BASE_URL}/ws/chat/${roomId}/?token=${token}`
      );

      const messageInput = document.querySelector('#chat-message-reply-input');
      const sendButton = document.querySelector('#chat-message-reply-submit');

      messageInput.focus();

      messageInput.addEventListener('keydown', (event) => {
        if (this.selection_type === 'press_enter' && event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          sendButton.click();
        }else{
            commonSocketConnectMethod.emit({
                type: "TypingEventForChat",
                message: 'typing',
                ChatRoomId: roomId
            });
            clearTimeout(this.typingTimeout); // Clear previous timeout using component property
            this.typingTimeout = setTimeout(() => { // Assign to component property
                commonSocketConnectMethod.emit({
                    type: "TypingEventForChat",
                    message: 'stop',
                    ChatRoomId: roomId
                });
            }, 2000);
          }
      });

      sendButton.addEventListener('click', () => {
        const message = messageInput.value.trim();

        if (message) {
          const payload = {
            chatRoomId: roomId,
            message: message,
            senderName: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
          };
          this.patientChatScoket.send(JSON.stringify({
            type: 'chat_message',
            message: {
              content: message,
            }
          }));
          commonSocketConnectMethod.emit({
              type: "TypingEventForChat",
              message: 'stop',
              ChatRoomId: roomId
          });
          bus.$emit('newChatMessage', payload);
          messageInput.value = '';
        }
      });

      this.patientChatScoket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if(data.type == 'readStatus') {
          if(this.lastLiveMsgData){
            this.allMessageListMethod();
        }
        return;
        }else{
          this.appendMessage(data.message, messagesList, this.selfUserId);
        }
      };

      this.patientChatScoket.onclose = (event) => {
        console.error("Socket Closed", event);
      };

      bus.$on('socketClosedNotifications', () => {
        this.chatClosedMethod();
      });
      
      this.$nextTick(() => {
        this.chatScrollAlwaysBottomMethod();
      });
    },

    appendMessage(data, messagesList, selfUserId) {
      const isSelfMessage = data.sender.user_id == selfUserId;
      const messageContainer = document.createElement("div");
      const messageItem = document.createElement("div");
      const timeWrapper = document.createElement("span");
      const timeElement = document.createElement("time");
      const formattedTime = moment(data.timestamp).format('h:mm a');

      // Use a single line to set multiple attributes and class names
      messageContainer.className = `append_pchatmsg ${isSelfMessage ? 'pchatmsg_recieved' : 'pchatmsg_sent'}`;
      messageItem.className = `pchat_msg_item ${isSelfMessage ? 'pchat_recieved_msg' : 'pchat_send_msg'}`;
      timeWrapper.className = 'msg_time_wrp';
      timeElement.className = 'msg_time';

      messageItem.textContent = data.decrypted_content;
      timeElement.textContent = formattedTime;

      timeWrapper.appendChild(timeElement);
      messageItem.appendChild(timeWrapper);
      messageContainer.appendChild(messageItem);

      if (isSelfMessage) {
        messageItem.appendChild(this.createReadStatusLabelMethod(data));
      }
      messagesList.appendChild(messageContainer);
      this.chatScrollAlwaysBottomMethod();
    },

    createReadStatusLabelMethod(data) {
      this.lastLiveMsgData = data;
      const labelReadS = document.createElement("label");
      labelReadS.classList.add('message_indication_label');
      const labelReadI = document.createElement("i");
      labelReadI.classList.add('msg_indicated_dot');
      const liveMsgs = document.querySelectorAll('#messages .msg_indicated_dot');
      const apiMsgs = document.querySelectorAll('#append_message .msg_indicated_dot');
      if (this.messagesIndicationStatusMethod(data.message_statuses) == 'read') {
        labelReadI.setAttribute("class", 'msg_indicated_dot read');
        // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          element.classList.remove('sent');
          element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
        })
        apiMsgs.forEach(element => {
          element.classList.remove('sent');
          element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
        })
      } else if (this.messagesIndicationStatusMethod(data.message_statuses) == 'delivered') {
        labelReadI.setAttribute("class", 'msg_indicated_dot sent');
         // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          if (!element.classList.contains('read')) {
              element.classList.remove('unsent');
              element.classList.add('sent');
          } // Replace 'your-new-class' with the class you want to add
        })
         apiMsgs.forEach(element => {
          if (!element.classList.contains('read')) {
              element.classList.remove('unsent');
              element.classList.add('sent');
          } // Replace 'your-new-class' with the class you want to add
        })
      } else {
        labelReadI.setAttribute("class", 'msg_indicated_dot unsent');
      }
        labelReadS.appendChild(labelReadI);
        return labelReadS;
    },

    /*
     * this will get All Message List again
    */
    allMessageListMethod() {
      this.$store.dispatch('getChatRoomDetailForPatientMethod', { id: this.chateRoomIdOfPateint.chat_room_id})
        .then(response => {
          const { data } = response.data;
          this.patientChatDetails = data;
          this.patientChatDetailResults = [].concat(data.results);
          this.msgNextPageLoader = data.next;
          // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
          if ($ && typeof $.fn.remove === 'function') {
            $('.append_pchatmsg').remove();
          } else {
            // console.warn("jQuery not available or .remove() not a function. Cannot remove '.append_pchatmsg' elements.");
            document.querySelectorAll('.append_pchatmsg').forEach(el => el.remove());
          }
          this.lastLiveMsgData = null; // Reset lastLiveMsgData to null
        })
    },
    chatScrollAlwaysBottomMethod() {
      const elmnt = document.getElementById("chat_msg_list_scroll");
      if (elmnt) {
        elmnt.scrollTop = elmnt.scrollHeight;
      }
    },

    chatClosedMethod() {
      if (this.patientChatScoket && this.patientChatScoket.readyState === WebSocket.OPEN) {
        this.patientChatScoket.close();
      }
    },

    /*
     * This Will Video Call Request Function
    */
    videoCallRequestFun(callerId, roomId) {
      this.callTextState = true;
      let callerFullName = this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name;
      commonSocketConnectMethod.emit({
        callerName: callerFullName,
        type: "videoCalling",
        callerID: this.selfUserId,
        targetId: callerId,
        roomId: roomId
      });
      commonSocketConnectMethod.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      commonSocketConnectMethod.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      commonSocketConnectMethod.$on('videoCallAlertPopupClosed', this.notrecievedCall);
      commonSocketConnectMethod.$on('autoMissedCallEvent', this.autoMissedCall);
    },
    getAnswerOfVideoCall(getAnswerData) {
      if (this.selfUserId == getAnswerData.targetId) {
        this.$router.push('/video/conference/#' + getAnswerData.roomId);
      }
      this.callTextState = false;
    },
    getDeclinedOfVideoCall() {
      this.callTextState = false;
    },
    notrecievedCall() {
      this.callTextState = false;
    },
    autoMissedCall() {
      this.callTextState = false;
    },
  },
  beforeDestroy() {
   this.chatClosedMethod();
    // document.getElementById("chat_msg_list_scroll").removeEventListener("scroll", this.handleMessageLoader);
  },
}